import { Link } from 'react-router-dom';
import type { Work } from '@/mocks/works';
import { getUserById } from '@/mocks/users';

interface Props {
  work: Work;
}

export default function WorkCard({ work }: Props) {
  const author = getUserById(work.authorId);
  return (
    <Link
      to={`/detail/${work.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all cursor-pointer"
    >
      <div className="w-full aspect-[4/5] overflow-hidden bg-background-100">
        <img
          src={work.cover}
          alt={`${work.title} - ${author?.nickname ?? ''}`}
          title={`${work.title} ${work.tags.join(' ')}`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="p-3">
        <h3 className="text-sm md:text-base font-medium text-foreground-900 truncate">{work.title}</h3>
        <div className="flex items-center justify-between mt-2">
          <div className="flex items-center gap-1.5 min-w-0">
            <img src={author?.avatar} alt={author?.nickname} className="w-5 h-5 rounded-full object-cover object-top flex-shrink-0" />
            <span className="text-xs text-foreground-600 truncate">{author?.nickname}</span>
          </div>
          <div className="flex items-center gap-1 text-foreground-500 flex-shrink-0">
            <i className="ri-heart-line text-xs"></i>
            <span className="text-xs">{work.likes}</span>
          </div>
        </div>
      </div>
    </Link>
  );
}